class FeaturePills extends HTMLElement {
  connectedCallback() {
    const buttons = this.querySelectorAll('.pill-btn');
    const lists = this.querySelectorAll('.pill-list');
    const images = this.querySelectorAll('.pill-img');

    const activate = (id) => {
      // buttons
      buttons.forEach(b => b.classList.toggle('active', b.dataset.target === id));
      // lists
      lists.forEach(l => l.classList.toggle('active', l.id === `pill-list-${id}`));
      // images: only the image(s) for this pill, and only ones not hidden by gender personalization
      images.forEach(img => {
        const isTarget = img.dataset.pill === id;
        img.classList.toggle('active', isTarget && !img.hidden);
      });
    };

    buttons.forEach(btn => {
      btn.addEventListener('click', () => activate(btn.dataset.target));
    });

    // Re-activate the current pill's image once gender personalization has
    // hidden/shown images, in case the active pill's image got hidden.
    document.addEventListener('gender-personalization:applied', () => {
      const activeBtn = this.querySelector('.pill-btn.active');
      if (activeBtn) activate(activeBtn.dataset.target);
    });
  }
}
if (!customElements.get('feature-pills')) {
  customElements.define('feature-pills', FeaturePills);
}